import React from 'react';
import { motion } from 'framer-motion';
import './ContactSection.css';

const ContactSection = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <section className="contact-section">
      <div className="container">
        <motion.div 
          className="contact-content"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <motion.div className="contact-card" variants={itemVariants}>
            <div className="contact-icon">💬</div>
            <div className="contact-text">
              <h4>ما زلت لديك أسئلة؟</h4>
              <p>لا تتردد في التواصل مع فريق التنظيم</p>
              <a href="mailto:tirahackathon@gmail.com" className="contact-email">
                tirahackathon@gmail.com
              </a>
            </div>
          </motion.div>
          
          {/* Gravnix promotional banner */}
          <motion.div className="gravnix-branding" variants={itemVariants}>
            <motion.div
              className="gravnix-banner"
              whileHover={{ scale: 1.02 }}
              transition={{ duration: 0.3 }}
              onClick={() => window.open('https://gravnix.com', '_blank')}
            >
              <div className="banner-content">
                <div className="banner-left">
                  <span className="banner-credits">
                    <span className="credit-text">Built by Gravnix</span>
                    <span className="credit-separator">•</span>
                    <span 
                      className="credit-text credit-link"
                      onClick={(e) => {
                        e.stopPropagation();
                        window.open('https://linkedin.com/in/najeebakh', '_blank');
                      }}
                    >
                      Coded & Designed by Najeeb Abu Kheit
                    </span>
                  </span>
                </div>
                <div className="banner-right">
                  <span className="banner-cta">Visit Gravnix</span>
                  <span className="banner-arrow">→</span>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactSection;
